// extracted by mini-css-extract-plugin
export default {"MyButton":"MyButton_MyButton__1BrIV"};